import { useNavigate, useParams } from 'react-router'
import { api } from '../api/client'
import type { User } from '../api/types'
import { useAuth } from '../auth/AuthProvider'
import { AuthCard } from '../components/AuthCard'
import { PasswordForm } from '../components/PasswordForm'

export function AcceptInviteScreen() {
	const { token } = useParams()
	const { setUser } = useAuth()
	const navigate = useNavigate()
	return (
		<AuthCard title="Create your account" subtitle="You’ve been invited to StoreKeeper.">
			<PasswordForm
				askName
				submitLabel="Create account"
				onSubmit={async ({ name, password }) => {
					setUser(await api.post<User>('/api/auth/accept-invite', { token, name, password }))
					navigate('/', { replace: true })
				}}
			/>
		</AuthCard>
	)
}
